import { URLS } from "@constants/urls";

import api from "@helpers/api";

import {
  OtherServiceType,
  PromotionParticularType,
  ServicesHistoryType,
  ServicesType,
} from "@type/HRM/services";

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${URLS.EMPLOYEES}`;

export const getServices = (() => {
  return async (data: { data: string }): Promise<{ data: ServicesType }> => {
    const id = data.data; // employee id
    return api
      .get(`${apiEndPoint}/${id}/service-info`)
      .then((response) => ({ data: response.data }));
  };
})();

export const updateServiceHistoryInfo = (() => {
  return async (data: {
    data: ServicesHistoryType;
  }): Promise<{ data: ServicesHistoryType }> => {
    const { id, ...rest } = data.data;
    const { employeeID } = rest;

    const action = id ? "put" : "post";

    const putUrl = `${apiEndPoint}/${employeeID}/service-info/service-histories/${id}`;
    const postUrl = `${apiEndPoint}/${employeeID}/service-info/service-histories`;
    const url = id ? putUrl : postUrl;

    return api[action](url, { ...rest }).then((response) => ({
      data: response.data,
    }));
  };
})();

export const updatePromotionParticularsInfo = (() => {
  return async (data: {
    data: PromotionParticularType;
  }): Promise<{ data: PromotionParticularType }> => {
    const { id, ...rest } = data.data;
    const { employeeID } = rest;

    const action = id ? "put" : "post";

    const putUrl = `${apiEndPoint}/${employeeID}/service-info/promotion-particulars/${id}`;
    const postUrl = `${apiEndPoint}/${employeeID}/service-info/promotion-particulars`;
    const url = id ? putUrl : postUrl;

    return api[action](url, { ...rest }).then((response) => ({
      data: response.data,
    }));
  };
})();

export const updateOtherServicesInfo = (() => {
  return async (data: {
    data: OtherServiceType;
  }): Promise<{ data: OtherServiceType }> => {
    const { id, ...rest } = data.data;
    const { employeeID } = rest;

    const action = id ? "put" : "post";

    const putUrl = `${apiEndPoint}/${employeeID}/service-info/other-services/${id}`;
    const postUrl = `${apiEndPoint}/${employeeID}/service-info/other-services`;
    const url = id ? putUrl : postUrl;

    return api[action](url, { ...rest }).then((response) => ({
      data: response.data,
    }));
  };
})();

export const deleteServicesHistoryInfo = (() => {
  return async (data: {
    data: { employeeID: number | null; servicesHistoryID: number };
  }): Promise<{ data: { id: number } }> => {
    const { servicesHistoryID, employeeID } = data.data;

    return api
      .delete(
        `${apiEndPoint}/${employeeID}/service-info/service-histories/${servicesHistoryID}`,
      )
      .then(() => ({ data: { id: servicesHistoryID } }));
  };
})();

export const deletePromotionParticularsInfo = (() => {
  return async (data: {
    data: { employeeID: number | null; promotionParticularID: number };
  }): Promise<{ data: { id: number } }> => {
    const { promotionParticularID, employeeID } = data.data;

    return api
      .delete(
        `${apiEndPoint}/${employeeID}/service-info/promotion-particulars/${promotionParticularID}`,
      )
      .then(() => ({ data: { id: promotionParticularID } }));
  };
})();

export const deleteOtherServicesInfo = (() => {
  return async (data: {
    data: { employeeID: number | null; otherServiceID: number };
  }): Promise<{ data: { id: number } }> => {
    const { otherServiceID, employeeID } = data.data;

    return api
      .delete(
        `${apiEndPoint}/${employeeID}/service-info/other-services/${otherServiceID}`,
      )
      .then(() => ({ data: { id: otherServiceID } }));
  };
})();
